import { render, staticRenderFns } from "./SettingLabel.vue?vue&type=template&id=55116be0&scoped=true&"
import script from "./SettingLabel.vue?vue&type=script&lang=js&"
export * from "./SettingLabel.vue?vue&type=script&lang=js&"
import style0 from "./SettingLabel.vue?vue&type=style&index=0&id=55116be0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55116be0",
  null
  
)

export default component.exports